import * as yup from 'yup';
import { InputController } from '../../components/hookForm/InputController';
import {
  MAX_PRODUCT_DESCRIPTION_LENGTH,
  MAX_PRODUCT_DIMENSION,
  MAX_PRODUCT_NAME_LENGTH,
  MAX_PRODUCT_PRICE,
  MIN_PRODUCT_DESCRIPTION_LENGTH,
  MIN_PRODUCT_DIMENSION,
  MIN_PRODUCT_NAME_LENGTH,
  MIN_PRODUCT_PRICE,
} from '../../constants/validationConstants';
import { apiCreateFilterOption } from '../../helpers/api';
import { dispatcher } from '../../helpers/projectHelper';
import { updateFilter } from '../../redux/slicers/filters/filterSlicer';

export const nameSchema = {
  name: yup.string().min(MIN_PRODUCT_NAME_LENGTH).max(MAX_PRODUCT_NAME_LENGTH).required(),
};

export const getIsRoofPropFields = (data) => [
  {
    name: 'is_roof_prop',
    placeholder: 'Roof Prop',
    value: data.is_roof_prop,
  },
];

export const getNameFields = (data) => [
  {
    name: 'name',
    placeholder: 'Product name',
    value: data.name,
  },
];

export const skuSchema = {
  sku_id: yup.string().min(MIN_PRODUCT_NAME_LENGTH).max(MAX_PRODUCT_NAME_LENGTH).required(),
};

export const getSkuFields = (data) => [
  {
    name: 'sku_id',
    placeholder: 'Product Sku ID',
    value: data.sku_id,
  },
];

export const getGtinFields = (data) => [
  {
    name: 'gtin',
    placeholder: 'GTIN',
    value: data.gtin || '',
  },
];

export const priceSchema = {
  price: yup
    .number()
    .typeError('Invalid price')
    .min(MIN_PRODUCT_PRICE, `Min price - ${MIN_PRODUCT_PRICE}`)
    .max(MAX_PRODUCT_PRICE, `Max price - ${MAX_PRODUCT_PRICE}`)
    .required('Invalid price'),
};

export const getPriceFields = (data) => [
  {
    name: 'price',
    placeholder: 'Price',
    value: data.price,
  },
];

export const descriptionSchema = {
  description: yup.string().min(MIN_PRODUCT_DESCRIPTION_LENGTH).max(MAX_PRODUCT_DESCRIPTION_LENGTH),
};

export const getDescriptionFields = (data) => [
  {
    name: 'description',
    placeholder: 'Description',
    value: data.description,
    Component: ({ control }) => {
      return (
        <InputController
          placeholder="Description"
          name="description"
          className="mb-3"
          multiline
          control={control}
          noResize
          height={172}
        />
      );
    },
  },
];

export const getLiveLinksFields = (data) => [
  {
    name: 'live_links',
    placeholder: 'Live Links ( comma separated )',
    value: data.live_links || '',
    Component: ({ control }) => {
      return (
        <InputController
          placeholder="Live Links ( comma separated )"
          name="live_links"
          className="mb-3"
          multiline
          control={control}
          noResize
          height={172}
        />
      );
    },
  },
];

export const dimensionsSchema = {
  dimensions: yup.string().min(MIN_PRODUCT_NAME_LENGTH).max(MAX_PRODUCT_NAME_LENGTH).required(),
};

export const getDimensionsFields = (data) => [
  {
    name: 'dimensions',
    placeholder: 'Dimensions',
    value: data.dimensions || '',
  },
];

export const getCategoryFields = (filter, filterValue) => {
  const name = `filter_${filter.id}`;

  const schema = {
    [name]: yup.array(),
  };

  // Commented out required validation - all category fields are now optional
  // const schema = filter?.is_product_page_filter
  //   ? {
  //       [name]: yup.array(),
  //     }
  //   : {
  //       [name]: yup
  //         .array()
  //         .typeError(`${filter.label_name} is required`)
  //         .test(
  //           'missing filter',
  //           `${filter.label_name} is required`,
  //           (arr) => arr && arr.length !== 0
  //         ),
  //     };

  return {
    schema,
    fieldsConfig: [
      {
        name: name,
        placeholder: filter.label_name,
        type: 'select',
        value: filterValue,

        selectProps: {
          options: filter.options,
          isSearchable: true,
          isMulti: true,
          creatable: true,
          components: {
            DropdownIndicator: null,
          },
          onCreateOption: async (newOptionName,stopUpdate= false) => {
            const result = await apiCreateFilterOption({ filterId: filter.id, options: [newOptionName]})
            if (result?.id && result?.options) {
              //Due to this state update, all data resets because the form re-renders, and the user-added data becomes null.
              // So, I added this condition.
              if(!stopUpdate){
                dispatcher(updateFilter(result));
              }
              const newOption = result.options.find(o => o.name.toLowerCase() === newOptionName.toLowerCase())
              return { value: newOption.id, label: newOption.name }
            }

            return 
          }
        },
      },
    ],
  };
};

export const tagsSchema = {
  'tags': yup.array()
};

export const getTagsFields = (tagsValue, loadSearchTagOptions, handleCreateTag) => {
  const name = 'tags';

  const schema = {
    [name]: yup.array()
  };

  return {
    schema,
    fieldsConfig: [
      {
        name: name,
        placeholder: 'Tags',
        type: 'select',
        value: tagsValue,

        selectProps: {
          loadOptions: loadSearchTagOptions,
          isSearchable: true,
          isMulti: true,
          creatable: true,
          onCreateOption: handleCreateTag,
          additional: {
            page: 1,
          },
          components: {
            DropdownIndicator: null,
          },
        },
      },
    ],
  };
};